import Color from 'color'

export function isLightColor(color) {
    let colorObjHandle = Color(color).alpha(1)
    return colorObjHandle.isLight() ? true : false
}
export function generateBgAndTextColor(color) {
    let colorObjHandle = Color(color).alpha(1)
    let textColor, bgColor, colorObj;
    if (colorObjHandle.isLight()) {
        textColor = colorObjHandle.mix(Color("white")).hsl().string();
        bgColor = colorObjHandle.mix(Color("black")).hsl().string();
    }
    else {
        textColor = "white"
        bgColor = colorObjHandle.mix(Color("white")).hsl().string()
    }
    colorObj = { textColor: textColor, bgColor: bgColor }
    return colorObj
}

export function getMenuHeight(className) {
    let eleHeight = Array.from(document.querySelectorAll(`.${className}`), el => el.clientHeight);
    return eleHeight[0]
}
export function requiredIf(type, condition) {
    return function (props, componentName) {
        if (typeof type !== "function") {
            return new Error(
                'Invalid react-required-if prop type supplied to ' + componentName + '. Validation failed.'
            );
        }

        if (typeof condition !== "function") {
            return new Error(
                'Invalid react-required-if condition supplied to ' + componentName + '. Validation failed.'
            );
        }

        var test = condition(props) ? type.isRequired : type;
        return test.apply(this, arguments);
    };
}


// WEBPACK FOOTER //
// ./src/components/common/utils.js